import React from 'react'
import './History.css'

const History = () => {
  return (
    <div>History</div>
  )
}

export default History